/**
 * הלוגו של GoCall (17/08/2026 — החליף את סימן ה-"M" הישן).
 *
 * שתי צורות:
 * - `full` (ברירת מחדל): ה-wordmark המלא — תמונה מ-public/gocall-logo.webp,
 *   בגובה `size` ורוחב אוטומטי (יחס ~3:1). מתאים לכל מקום שיש בו רוחב.
 * - `mark`: סימן ריבועי קומפקטי (G + חץ-חיוך) — לסרגל צד מכווץ ולכל
 *   מקום ש-wordmark רחב לא נכנס בו. זהה ל-favicon.
 *
 * הצבעים קבועים מהמותג (נדגמו מהלוגו: #09C7CE / #05204C) ולא מ-tokens —
 * לוגו לא מחליף צבע עם ערכת הנושא.
 */
export function LogoMark({ size = 28, variant = 'full' }: { size?: number; variant?: 'full' | 'mark' }) {
  if (variant === 'mark') {
    return (
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none"
        xmlns="http://www.w3.org/2000/svg" aria-label="GoCall">
        <path d="M23.5 8.5 A10 10 0 1 0 26 15.5 H17.5"
          stroke="#09C7CE" strokeWidth="4.6" strokeLinecap="round" fill="none" />
        <path d="M8.5 27.5 Q16 31.5 24.5 26.5"
          stroke="#05204C" strokeWidth="2.6" strokeLinecap="round" fill="none" />
        <path d="M22.2 24.6 L25.6 26 L24.5 29.4"
          stroke="#05204C" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" fill="none" />
      </svg>
    );
  }

  return (
    <img
      src="/gocall-logo.webp"
      alt="GoCall"
      // gocall-logo: בערכת נושא כהה ה"Call" הנייבי נעלם על הרקע —
      // global.css הופך את הלוגו ללבן-מונוכרום שם (filter).
      className="gocall-logo"
      style={{ height: size, width: 'auto', display: 'block' }}
      draggable={false}
    />
  );
}
